export const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export const easeInOut: [number, number, number, number] = [0.77, 0, 0.175, 1];

export function staggerDelay(index: number, step = 0.04, max = 0.3): number {
  return Math.min(index * step, max);
}
